module.exports = __webpack_public_path__ + "media/images/hometown-d8da87ea1bf0e6effa243bbd16e1e6d4.svg";